import { rdrRequests, rdRequests, authorizedRDRequests,rdPublicRequests } from "../httpRequest";

const settingsRequest = {
    loadEnterprise: (domain: string) => rdPublicRequests.get(`webaccesscustomer/load/enterprise?domainUrl=${domain}`),
    getWebMenu: () => rdrRequests.get('search/popular/WebMenu'),
    getWebSiteSettings: () => rdrRequests.get('enterprise/websitesettings'),
    getConfigMessage: () => rdrRequests.get('search/popular/DynamicConfigMessage'),
    getEnterpriseSetting: () => rdrRequests.get('enterprise/settings'),
    getFutureBookingStartsEndsDates: (requestData: any) => rdPublicRequests.post('webaccessfacility/futurebookingstartsendsdates', requestData),
    getWebSecuritySettings: () => rdPublicRequests.get(`webaccesscustomer/load/websitesecuritysettings`),
    getContactUsSubject: () => rdRequests.get(`webaccesscustomer/ContactUsSubjects`),
    submitContactUs: (requestData: any) => rdRequests.post('webaccesscustomer/Send/ContactUsEmail', requestData),
    checkAuthorizeLogin: () => authorizedRDRequests.post('webaccesscustomer/check/authorizelogin', {}),    
    getContactUsPlaceInfo: (isVolunteer: boolean) => rdRequests.get(`webaccesscustomer/GetContactUsParkPlaceInfo?isVolunteer=${isVolunteer}`),
    getCMSPageContent: (pageName:string) => rdPublicRequests.get(`webaccesscustomer/GetCMSContentDetail?pageName=${pageName}`) ,
    getSystemTime:() => rdPublicRequests.get('webaccesscustomer/Get/SystemTime')
}

export default settingsRequest;